<template>
  <v-card @click="goToShowPost(post)" height="380px" width="auto" class="mx-1">
    <v-img 
      :src="post.main_image" 
      height="200px" 
      aspect-ratio="2.75"
      class="hover"
    ></v-img>
    <v-card-title primary-title>
      <div
        :title="post.full_title"
        class="text-24-security blue-security font-weight-bold line-heigth-security"
      >{{ post.title }}</div>
    </v-card-title>
    <v-card-actions>
      <div class="caption-security grey-security">{{ post.published_at }}</div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapMutations("posts", ["setPost"]),
    goToShowPost(item) {
      this.setPost(item);
      if (item.post_type == "VIDEO") {
        this.$router.push({
          name: "post-moment-show",
          params: { id: item.id, slug: item.slug }
        });
      } else {
        this.$router.push({
          name: "post-show",
          params: { id: item.id, slug: item.slug }
        });
      }
    }
  }
};
</script>

<style>
</style>